import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { first } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { AuthenticationService, NotificationService, EnvService, TxKeywordService, TxMtLogService } from '../../_services';


@Component({
  templateUrl: './mt-log.component.html'
})
export class TxMtLogComponent implements OnInit {
  mtLogs: Array<any> = [];
  loading = false;
  processing = false;
  //pagination
  itemsPerPage = 20;
  pagingList = [20, 40, 60, 80, 100];
  totalItems = 0;
  maxSize = 11;
  numPages = 0;
  currentPage = 1;
  page: number;
  goToPage: number;
  emptyResult = true;
  maxPageSize: number;

  filterable = {
    fromDate: '',
    phone: '',
    toDate: new Date().toISOString().substring(0, 10),
    state: '',
    type: '',
    panOutState: '',
    shortCode: null,
    keyword: null,
    operator: null,
    source: null,
    country: null
  };

  sourceList = [];
  countryList: any = {};
  keywordList: any =[];
  shortCodeList = [];
  operatorList: any = [];
  panOutStateList = {};
  typeList = {};
  stateList = {};

  allShortCodes = [];
  targetShortCode = null;

  constructor(private authSvc: AuthenticationService,
    private envSvc: EnvService,
    private keywordSvc: TxKeywordService,
    private mtLogSvc: TxMtLogService,
    private notification: NotificationService) {

  }

  ngOnInit(): void {
    let dte = new Date();
    dte.setDate(dte.getDate() - 1);
    this.filterable.fromDate = dte.toISOString().substring(0, 10);
    this.loadSources();
    this.loadEventTypes();
    this.loadPanOutStates();
    this.loadState();
    this.loadAllShortCodes();
  }

  search() {
    this.totalItems = 0;
    this.loadPage(1);
  }

  clear(): void {
    let dte = new Date();
    dte.setDate(dte.getDate() - 1);
    this.filterable = {
      fromDate: dte.toISOString().substring(0, 10),
      phone: '',
      toDate: new Date().toISOString().substring(0, 10),
      state: '',
      type: '',
      panOutState: '',
      shortCode: null,
      keyword: null,
      operator: null,
      source: null,
      country: null
    };
    this.keywordList = [];
    this.shortCodeList = [];
    this.operatorList = [];
    this.targetShortCode = null;
    this.loadSources();
  }

  setPage(pageNo: number): void {
    this.currentPage = pageNo;
    this.loadPage();
  }

  pageChanged(event: any): void {
    this.page = event.page;
    if (this.page != this.currentPage) {
      this.loadPage(this.page);
    }
  }

  itemsPerPageChange(deviceValue) {
    this.itemsPerPage = deviceValue;
    this.loadPage(1);
  }

  onClear() {
    this.filterable.shortCode = null;
    this.filterable.keyword = null;
    this.keywordList = [];
    this.targetShortCode = null;
  }

  gotoTargetShortCode(targetShortCode){
    if(targetShortCode){
      let source = this.sourceList.find(it => {return it.value == targetShortCode.source});
      this.changeSource(source, targetShortCode);
    }
  }

  changeSource(source, targetShortCode = null) {
    if(!targetShortCode){
      this.targetShortCode = null;
    }
    this.filterable.source = source;
    this.shortCodeList = [];
    this.keywordList = [];
    this.countryList = {};
    this.operatorList = {};
    this.filterable.shortCode = null;
    this.filterable.keyword = null;
    this.filterable.operator = null;
    this.filterable.country = null;
    if (source) {
      this.countryList = source.subOptions;
      var targetCountry;
      if(targetShortCode){
        targetCountry = targetShortCode.country;
      }else{
        targetCountry = this.countryList[Object.keys(this.countryList)[0]];
      }
      this.changeCountry(targetCountry, targetShortCode);
    }
  }

  changeCountry(country, targetShortCode = null) {
    if(!targetShortCode){
      this.targetShortCode = null;
    }
    this.filterable.country = country;
    this.shortCodeList = [];
    this.keywordList = [];
    this.operatorList = {};
    this.filterable.shortCode = null;
    this.filterable.keyword = null;
    this.filterable.operator = null;
    if (country) {
      this.keywordSvc.getSelectionScAndKws(this.filterable.source.value, country).subscribe(data => {
        this.operatorList = data.data;
        if(targetShortCode){
          this.changeOperator(targetShortCode.operator, targetShortCode);
        }
      });
    }
  }

  changeOperator(operator, targetShortCode = null) {
    if(!targetShortCode){
      this.targetShortCode = null;
    }
    this.filterable.operator = operator;
    this.shortCodeList = [];
    this.keywordList = [];
    this.filterable.shortCode = null;
    this.filterable.keyword = null;
    if (operator) {
      console.log("operator: " + operator);
      console.log("operalist : " + this.operatorList);

      this.shortCodeList = Object.keys(this.operatorList[this.filterable.operator]);

      if(targetShortCode){
        this.changeShortCode(targetShortCode.shortCode, targetShortCode);
      }
    }
  }

  changeShortCode(shortCode, targetShortCode = null) {
    this.filterable.shortCode = shortCode;
    this.keywordList = [];
    this.filterable.keyword = null;
    if (shortCode) {
      this.keywordList = this.operatorList[this.filterable.operator][shortCode];
    }
    if(!targetShortCode){
      this.targetShortCode = this.allShortCodes.find(it => {return it.shortCode == this.filterable.shortCode && it.operator == this.filterable.operator});
    }
  }

  private loadSources() {
    this.keywordSvc.getSelectionSources().pipe(first()).subscribe(data => {
      this.sourceList = data.data;
      this.filterable.source = data.data[0];
      this.countryList = data.data[0].subOptions;
      var key = Object.keys(data.data[0].subOptions)[0];
      var value = data.data[0].subOptions[key];
      this.filterable.country = value;
      this.changeCountry(value);
    });
  }

  private loadEventTypes() {
    this.envSvc.getTxMtEventTypes().pipe(first()).subscribe(data => {
      this.typeList = data.data;
    });
  }

  private loadState() {
    this.envSvc.getTxMtStates().pipe(first()).subscribe(data => {
      this.stateList = data.data;
    });
  }

  private loadPanOutStates() {
    this.envSvc.getPanOutStates().pipe(first()).subscribe(data => {
      this.panOutStateList = data.data;
    });
  }

  private loadAllShortCodes(){
    this.keywordSvc.allShortCodeForSelection().pipe(first()).subscribe(data => {
      if(data){
        this.allShortCodes = data.data;
      }
    });
  }

  private loadPage(page = null) {
    this.loading = true;
    this.emptyResult = false;
    this.mtLogs = [];
    let params = this.formParam(page);
    // get page of items from api
    this.mtLogSvc.getAll(params).pipe(first()).subscribe(data => {
      if (data.status !== null) {
        this.loading = false;
        this.emptyResult = false;
        this.mtLogs = data.data.list;
        this.totalItems = data.data.total;
        this.currentPage = data.data.page + 1;
        this.maxPageSize = Math.ceil(data.data.total / data.data.pageSize) < 1 ? 1 : Math.ceil(data.data.total / data.data.pageSize);
      } else {
        this.loading = false;
        this.emptyResult = true;
        var notiMsg = data.msg == "Awesome!" ? "There is no record for this search." : data.msg;
        this.notification.showWarning(notiMsg, "Empty Result");
      }
    });
  }

  private formParam(page = null) {
    let params = {
      pageSize: this.itemsPerPage || 20,
      page: page == null ? this.currentPage - 1 : page - 1,
      fromDate: formatDate(this.filterable.fromDate, 'yyyyMMdd', 'en'),
      phone: this.filterable.phone,
      toDate: formatDate(this.filterable.toDate, 'yyyyMMdd', 'en'),
      state: this.filterable.state,
      type: this.filterable.type,
      panOutState: this.filterable.panOutState,
      shortCode: this.filterable.shortCode,
      keyword:  this.filterable.keyword == null ? "" : this.filterable.keyword,
      operator: this.filterable.operator,
      country: this.filterable.country,
      source: this.filterable.source.value
    }
    return params;
  }

}
